import gql from 'graphql-tag'

export const READ_CHAT_LOCALIZATION_TEXT_JSON = gql`
  query ReadChatLocalizationTextJson($localizationTextInput: LocalizationTextInput!) {
    readChatLocalizationTextJson(localizationTextInput: $localizationTextInput)
  }
`
